import React, { useState } from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption,
  Table,
  Container,
  Row,
  Col,
} from "reactstrap";
// core components
import { useNavigate } from "react-router-dom";
import AuthHeader from "components/Headers/AuthHeader.js";
import Cookies from "universal-cookie";
import { API } from "services/API";
import { getAnalytics, logEvent } from "firebase/analytics";

export default function FoundingAngler() {
  const analytics = getAnalytics();
  const [deviceType, setDeviceType] = useState("Web");
  const deviceWidth = window.innerWidth;
  const items = [
    {
      src: require("assets/img/carousel_ss/Apple iPhone 16 Pro Max Screenshot 1.png"),
    },
    {
      src: require("assets/img/carousel_ss/Apple iPhone 16 Pro Max Screenshot 2.png"),
    },
    {
      src: require("assets/img/carousel_ss/Apple iPhone 16 Pro Max Screenshot 3.png"),
    },
    {
      src: require("assets/img/carousel_ss/Apple iPhone 16 Pro Max Screenshot 4.png"),
    },
    {
      src: require("assets/img/carousel_ss/Apple iPhone 16 Pro Max Screenshot 5.png"),
    },
    {
      src: require("assets/img/carousel_ss/Apple iPhone 16 Pro Max Screenshot 6.png"),
    },
  ];
  // if (window.innerWidth < 1000) {
  //   items[0].src = require("assets/img/carousel/lookingatphone_mobile.jpg");
  //   items[2].src = require("assets/img/carousel/bassboat_mobile.jpeg");
  //   items[1].src = require("assets/img/carousel/kidsfishing_mobile.jpg");
  // } else {
  //   items[0].src = require("assets/img/carousel_ss/Apple iPhone 16 Pro Max Screenshot 1.png");
  //   items[1].src = require("assets/img/carousel_ss/Apple iPhone 16 Pro Max Screenshot 2.png");
  //   items[2].src = require("assets/img/carousel_ss/Apple iPhone 16 Pro Max Screenshot 3.png");
  //   items[3].src = require("assets/img/carousel_ss/Apple iPhone 16 Pro Max Screenshot 4.png");
  //   items[4].src = require("assets/img/carousel_ss/Apple iPhone 16 Pro Max Screenshot 5.png");
  //   items[5].src = require("assets/img/carousel_ss/Apple iPhone 16 Pro Max Screenshot 6.png");
  // }
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  const slides = items.map((item) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.src}
      >
        <img src={item.src} alt={item.altText} width="100%" />
        {/* <CarouselCaption
          className="carousel-caption-homepage"
          captionText={item.altText}
          captionHeader={item.caption}
        /> */}
      </CarouselItem>
    );
  });

  let cookies = new Cookies();
  const redir = useNavigate();
  React.useEffect(() => {
    if (
      cookies.get("fishuem") !== undefined &&
      cookies.get("fishuid") !== undefined &&
      cookies.get("fishuimg") !== undefined &&
      cookies.get("fishuname") !== undefined
    ) {
      localStorage.setItem("fishuem", cookies.get("fishuem"));
      localStorage.setItem("fishuid", cookies.get("fishuid"));
      localStorage.setItem("fishuimg", cookies.get("fishuimg"));
      localStorage.setItem("fishuname", cookies.get("fishuname"));
      // localStorage.setItem("fishuexp", moment().add(15, "m").format());
      API.interceptors.request.use(function (config) {
        config.headers = {
          "Content-Type": "multipart/form-data",
          "X-EncId": localStorage.getItem("fishuid"),
          "X-EncEm": localStorage.getItem("fishuem"),
        };
        return config;
      });
      redir("/admin/homecatchlist");
    }
    document.title = "Bite Logr";
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/iPhone|iPad|iPod/i.test(userAgent)) {
      setDeviceType("iPhone");
    } else if (/android/i.test(userAgent)) {
      setDeviceType("Android");
    } else {
      setDeviceType("Web");
    }
  }, []);
  return (
    <>
      <AuthHeader deviceType={deviceType} />
      <Container className="mt--9 pb-5">
        <Row className="justify-content-center">
          <Col lg="6">
            <Card className="card-pricing border-0 text-center mb-4">
              <CardHeader className="bg-transparent">
                <h2 className="text-uppercase ls-1 text-bold pt-3 mb-0">
                  Become a Founding Angler
                </h2>
              </CardHeader>
              <CardBody className="px-lg-5">
                <div className="text-center mb-4">
                  <img
                    alt="..."
                    style={{ maxHeight: "100px" }}
                    src={require("assets/img/brand/biteLogrLogos/LOGO.png")}
                  />
                </div>
                <p className="text-lead">
                  We are looking for 10-20 pro anglers to help us get rolling.
                  <br></br>
                  You will receive:
                  <ul className="text-left">
                    <li>Concierge Setup</li>
                    <li>ZERO platform fees for life</li>
                    <li>
                      Promo help from us including FREE paid ads for your social
                      kedia accounts
                    </li>
                  </ul>
                </p>
                <p className="text-lead">
                  Turn your fishing knowledge into passive income
                </p>
                <p className="text-lead">
                  Bite Logr lets pro anglers get paid for their patterns. Share
                  your fish, set your price and build a loyal following of
                  anglers who want to learn from you.
                </p>
              </CardBody>
            </Card>
            <Row className="justify-content-center mb-5">
              <Button
                className="btn-icon btn-3"
                color="secondary"
                type="button"
                onClick={() => {
                  document.location = "https://forms.gle/JskKmDFfKo2RFdKUA";
                }}
              >
                <span className="btn-inner--text">Apply Now</span>
              </Button>
            </Row>
          </Col>
          <Col lg="4">
            <Carousel
              activeIndex={activeIndex}
              next={next}
              previous={previous}
              ride="carousel"
              dark={true}
            >
              <CarouselIndicators
                items={items}
                activeIndex={activeIndex}
                onClickHandler={goToIndex}
              />
              {slides}
              <CarouselControl
                direction="prev"
                directionText="Previous"
                onClickHandler={previous}
              />
              <CarouselControl
                direction="next"
                directionText="Next"
                onClickHandler={next}
              />
            </Carousel>
          </Col>
        </Row>

        <Row className="justify-content-center m-4">
          <Col lg="10">
            <Card className="card-pricing border-0 text-center mb-4">
              <CardHeader className="bg-transparent">
                <h2 className="text-uppercase ls-1 text-info pt-3 mb-0">
                  Why?
                </h2>
              </CardHeader>
              <CardBody className="px-lg-5">
                <span className="text-muted">
                  Most pros spend their lives building knowledge they can't
                  monetize. Bite Logr turns your hard-earned expertise into
                  passive income -- and helps teach the next generation how to
                  catch.
                </span>
                <h3 className="text-info mt-5 mb-2">Not a Pro?</h3>
                <span className="text-muted">
                  Follow the pros on your local waters.
                  <br />
                  See what is working and when -- and catch more fish without
                  the guesswork.
                </span>
                <div className="mt-4">
                  {deviceType === "Web" && (
                    <Row className="justify-content-center">
                      <Button
                        className="btn-icon btn-3"
                        color="info"
                        type="button"
                        onClick={() => {
                          document.location = "/auth/register";
                        }}
                      >
                        <span className="btn-inner--text">Register</span>
                      </Button>
                    </Row>
                  )}
                  {deviceType === "iPhone" && (
                    <Row className="justify-content-center">
                      <Button
                        className="btn-icon btn-3"
                        color="info"
                        type="button"
                        onClick={() => {
                          logEvent(analytics, "get_app_apple");
                          document.location =
                            "https://apps.apple.com/us/app/bite-logr/id6737280925";
                        }}
                      >
                        <span className="btn-inner--icon">
                          <i className="fab fa-apple" />
                        </span>
                        <span className="btn-inner--text">Get App</span>
                      </Button>
                    </Row>
                  )}
                  {deviceType === "Android" && (
                    <Row className="justify-content-center">
                      <Button
                        className="btn-icon btn-3"
                        color="info"
                        type="button"
                        onClick={() => {
                          logEvent(analytics, "get_app_android");
                          document.location =
                            "https://play.google.com/store/apps/details?id=com.mlehmann.BiteLogr";
                        }}
                      >
                        <span className="btn-inner--icon">
                          <i className="fab fa-android" />
                        </span>
                        <span className="btn-inner--text">Get App</span>
                      </Button>
                    </Row>
                  )}
                </div>
              </CardBody>
              <CardFooter>
                <a
                  className="text-light"
                  href="https://www.facebook.com/profile.php?id=61553952532799"
                  target="_blank"
                >
                  Contact Us
                </a>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
